<div class="page-header">
    <div class="container">
        <h3 *ngIf="subtitle" class="subtitle">{{subtitle}}</h3>
        <h1 *ngIf="title" class="title">{{title}}</h1>
    </div>
</div>
